import React from 'react';
import { Card, CardContent, Divider, Grid, Typography, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

interface DataBlock {
  data: {
    label: string;
    value: string | number | React.ReactElement; // Can be text or a component
  }[];
}

interface SummaryDetailsBlockProps {
  title: string;
  backgroundColor?: string;
  subTitle?: string;
  dataBlocks: DataBlock[];
  onEdit?: () => void;
}

const SummaryDetailsBlock: React.FC<SummaryDetailsBlockProps> = ({ title, subTitle, dataBlocks, backgroundColor, onEdit }) => {
  return (
    <Card sx={{ backgroundColor: backgroundColor }} variant="outlined">
      <CardContent sx={{ px: 0, pt: 1, pb: '16px !important' }}>
        <Grid alignItems={'center'} container columnSpacing={2} px={2} pb={1} mb={2} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Grid item xs={4}>
            <Typography variant="subtitle1" fontWeight="bold">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            {subTitle && (
              <Typography variant="body2" color="grey.600">
                {subTitle}
              </Typography>
            )}
          </Grid>
          <Grid display={'flex'} justifyContent={'flex-end'} item xs>
            {onEdit && (
              <Button startIcon={<EditIcon />} onClick={onEdit}>
                Edit
              </Button>
            )}
          </Grid>
        </Grid>

        {dataBlocks.map((block, blockIdx) => (
          <React.Fragment key={blockIdx}>
            {blockIdx > 0 && <Divider sx={{ my: 2 }} />}

            <Grid px={2} rowSpacing={2} container>
              {block.data.map(({ label, value }, idx) => (
                <Grid container columnSpacing={2} item key={idx}>
                  <Grid item xs={4}>
                    <Typography variant="body2" color="text.secondary">
                      {label}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {typeof value === 'string' && <Typography variant="body2">{value}</Typography>}
                    {typeof value === 'object' && value}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </React.Fragment>
        ))}
      </CardContent>
    </Card>
  );
};

export default SummaryDetailsBlock;
